import { NavigationMenuLink } from '@/atoms/components/ui/navigation-menu'
import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import { MenuShell } from './DesktopNav'
import Image from 'next/image'

export const SolutionsMenu = () => {
  return (
    <MenuShell>
      <div className="grid gap-6 lg:grid-cols-[3fr_1fr]">
        <div className="grid gap-4 md:grid-cols-2">
          <NavigationMenuLink asChild>
            <Link
              href="/solutions/seo"
              className="rounded-2xl border border-[#4242B6] p-4 grid grid-cols-[1fr_auto_auto] gap-4 grid-rows-[auto_1fr] bg-[#060135]"
            >
              <p className="text-base font-semibold text-slate-900 col-[1/2] row-[1/2]">
                Pepper SEO + GEO
              </p>
              <ArrowRight className="h-4 w-4 text-slate-500 | col-[3/4] row-[1/2]" />
              <p className="text-sm text-slate-600 | col-[1/2] row-[2/3]">
                Grow visibility across Google, YouTube, and AI platforms with
                precision. We blend search strategy, expert-driven optimization,
                and continuous optimization to keep your brand discoverable
                across every search surface.
              </p>
              <div className="relative col-[2/3] row-[2/3] | aspect-auto w-[100px]">
                <Image
                  fill
                  src="/assets/inc/nav/solutions__pepper-seo-geo.png"
                  alt=""
                  className="object-contain"
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/video-services/"
              className="rounded-2xl border border-[#4242B6] p-4 grid grid-cols-[1fr_auto_auto] gap-4 grid-rows-[auto_1fr] bg-[#060135]"
            >
              <p className="text-base font-semibold text-slate-900 col-[1/2] row-[1/2]">
                Pepper Creative
              </p>
              <ArrowRight className="h-4 w-4 text-slate-500 | col-[3/4] row-[1/2]" />

              <p className="text-sm text-slate-600 | col-[1/2] row-[2/3]">
                Bring your brand to life with insight-led storytelling. Creative
                directors, designers, and copy specialists craft campaigns
                powered by AI agents and grounded in strategy - built to connect
                and convert.
              </p>
              <div className="relative col-[2/3] row-[2/3] | aspect-auto w-[100px]">
                <Image
                  fill
                  src="/assets/inc/nav/solutions__pepper-creative.png"
                  alt=""
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/solutions/content"
              className="rounded-2xl border border-[#4242B6] p-4 grid grid-cols-[1fr_auto_auto] gap-4 grid-rows-[auto_1fr] bg-[#060135]"
            >
              <p className="text-base font-semibold text-slate-900 col-[1/2] row-[1/2]">
                Pepper Content
              </p>
              <ArrowRight className="h-4 w-4 text-slate-500 | col-[3/4] row-[1/2]" />
              <p className="text-sm text-slate-600 | col-[1/2] row-[2/3]">
                Turn ideas into revenue-driving content. From strategy to
                creation, our AI-assisted workflows and expert-led approach
                deliver stories that build authority, trust, and organic growth.
              </p>
              <div className="relative col-[2/3] row-[2/3] | aspect-auto w-[100px]">
                <Image
                  fill
                  src="/assets/inc/nav/solutions__pepper-content.png"
                  alt=""
                />
              </div>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/solutions/ai"
              className="rounded-2xl border border-[#4242B6] p-4 grid grid-cols-[1fr_auto_auto] gap-4 grid-rows-[auto_1fr] bg-[#060135]"
            >
              <p className="text-base font-semibold text-slate-900 col-[1/2] row-[1/2]">
                Pepper AI
              </p>
              <ArrowRight className="h-4 w-4 text-slate-500 | col-[3/4] row-[1/2]" />
              <p className="text-sm text-slate-600 | col-[1/2] row-[2/3]">
                Infuse intelligence into every workflow. Our strategists and
                technologists use AI to streamline production, unlock scale
                faster, and measure content impact with clarity.
              </p>
              <div className="relative col-[2/3] row-[2/3] | aspect-auto w-[100px]">
                <Image
                  fill
                  src="/assets/inc/nav/solutions__pepper-ai.png"
                  alt=""
                />
              </div>
            </Link>
          </NavigationMenuLink>
        </div>

        <div className="rounded-2xl border border-[#4242B6] p-4 space-y-3 bg-[#060135]">
          <p className="text-base font-semibold text-slate-900 col-[1/2] row-[1/2]">
            Industries
          </p>
          <div className="text-sm text-slate-600 | grid grid-cols-[auto_1fr_1.5rem] grid-rows-4 gap-3">
            <NavigationMenuLink asChild>
              <Link
                href="/industries/b2b-saas/"
                className="grid grid-cols-subgrid col-span-full items-center py-2"
              >
                <img
                  src="/assets/inc/nav/b2b-software.svg"
                  alt="icon"
                  className="size-4 col-[1/2] row-[1/2] self-center justify-self-center"
                />
                <span className="col-[2/3]">B2B Software</span>
                <ArrowRight className="h-4 w-4 text-slate-500 col-[3/4]" />
              </Link>
            </NavigationMenuLink>
            <NavigationMenuLink asChild>
              <Link
                href="/industries/bfsi/"
                className="grid grid-cols-subgrid col-span-full items-center py-2"
              >
                <img
                  src="/assets/inc/nav/banking.svg"
                  alt="icon"
                  className="size-4 col-[1/2] row-[1/2] self-center justify-self-center"
                />
                <span className="col-[2/3]">
                  Banking, Financial Services and Insurance
                </span>
                <ArrowRight className="h-4 w-4 text-slate-500 col-[3/4]" />
              </Link>
            </NavigationMenuLink>
            <NavigationMenuLink asChild>
              <Link
                href="/industries/fmcg-cpg/"
                className="grid grid-cols-subgrid col-span-full items-center py-2"
              >
                <img
                  src="/assets/inc/nav/retail.svg"
                  alt="icon"
                  className="size-4 col-[1/2] row-[1/2] self-center justify-self-center"
                />
                <span className="col-[2/3]">CPG and Retail</span>
                <ArrowRight className="h-4 w-4 text-slate-500 col-[3/4]" />
              </Link>
            </NavigationMenuLink>
            <NavigationMenuLink asChild>
              <Link
                href="#"
                className="grid grid-cols-subgrid col-span-full items-center py-2"
              >
                <img
                  src="/assets/inc/nav/consumer.svg"
                  alt="icon"
                  className="size-4 col-[1/2] row-[1/2] self-center justify-self-center"
                />
                <span className="col-[2/3]">
                  Consumer Tech, DTC & E-commerce
                </span>
                <ArrowRight className="h-4 w-4 text-slate-500 col-[3/4]" />
              </Link>
            </NavigationMenuLink>
          </div>
        </div>
      </div>
    </MenuShell>
  )
}
